<mat-card>
  <div class="header">
    <mat-card-title>{{ title() }}</mat-card-title>
    <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
      <vulcan-icon size="24px" icon="download"></vulcan-icon>
    </button>
  </div>
  <mat-card-content #exportContent>
    @if (imageUrl()) {
      <img [src]="imageUrl()" alt="SRC Image"/>
    } @else {
      <span> Loading... </span>
    }
  </mat-card-content>
</mat-card>
